export default __webpack_public_path__ + "static/media/04-technology.f2048e71.jpg";